import type { EventTriggerPopupData } from '../stores/event-trigger/types';
import { useStores } from '../stores/useStores';
import type { LimitedOfferStock } from '../utils/limitedOffer';
import { getLimitedOfferConfig, getPlayerLimitedOfferStock } from '../utils/limitedOffer';

/**
 * Live simulated stock for a Limited Offer, or null for every other event.
 *
 * The caller must be wrapped in `observer()`: the 1s cadence comes from reading the offer's
 * countdown, which `EventTriggerStore.startTimers()` already ticks, so the counter needs no interval
 * of its own. That read is deliberately placed after the config check — `setTimers` reassigns the
 * whole observable every second, so subscribing earlier would re-render the caller once a second for
 * every offer, limited or not.
 *
 * Each call recomputes from absolute time, so a throttled or skipped tick self-corrects instead of
 * accumulating drift.
 */
export const useLimitedOfferStock = (event?: EventTriggerPopupData | null): LimitedOfferStock | null => {
  const { eventTriggerStore } = useStores();

  const config = getLimitedOfferConfig(event);
  if (!config || !event) return null;

  void eventTriggerStore.timers[event.userEventTriggerId];

  return getPlayerLimitedOfferStock(event, Date.now());
};
